module.exports = __webpack_public_path__ + "static/WelcomeToElk12-4baede1d99991da6206af27e8151e3b2.png";